export function shouldBypassResponseHandling(config) {
  return Boolean(config && config.vconfig && config.vconfig.noErr)
}

export function resolveResponseHandling(res) {
  if (shouldBypassResponseHandling(res.config)) {
    return {
      type: 'bypass',
      payload: res
    }
  }

  const data = res.data || {}
  const code = data.code

  if (code === '-5' || data.error === 'please login') {
    return {
      type: 'auth_expired',
      payload: data
    }
  }

  if (+code !== 0) {
    return {
      type: 'business_error',
      payload: data
    }
  }

  return {
    type: 'success',
    payload: data
  }
}

export function classifyTransportError(error) {
  if (error && error.response && error.response.status === 401) {
    return 'auth_expired'
  }

  if (error && error.message === 'cancel') {
    return 'cancel'
  }

  return 'transport_error'
}

export function resolveErrorMessage(error) {
  if (error && error.response && error.response.data && error.response.data.error) {
    return error.response.data.error
  }

  if (error && error.error) {
    return error.error
  }

  if (error && error.message) {
    return error.message
  }

  return 'Request failed'
}
